"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cleanObject(obj) {
    const getNewObj = { ...obj };
    if (obj) {
        const propNames = Object.keys(obj);
        for (const prop of propNames) {
            if (!getNewObj.hasOwnProperty(prop) ||
                getNewObj[prop] === undefined ||
                getNewObj[prop] === null ||
                getNewObj[prop] === "") {
                delete getNewObj[prop];
            }
        }
    }
    return getNewObj;
}
exports.default = cleanObject;
